/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {boolean} isDynamic
 */
export function setDynamicPageTitle(state, isDynamic) {
  state.dynamicPageTitle = isDynamic;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function idbReady(state) {
  state.idbReadyResolve();
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function ready(state) {
  state.readyResolve();
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function routerReady(state) {
  state.routerReadyResolve();
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {import('src/workers/Api').default} worker
 */
export function setApiWorker(state, worker) {
  state.apiWorker = worker;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {import('src/workers/DataBroker').default} broker
 */
export function setBroker(state, broker) {
  state.broker = broker;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {import('@capacitor/core').DeviceInfo} deviceInfo
 */
export function setDeviceInfo(state, deviceInfo) {
  state.deviceInfo = deviceInfo;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {boolean} isFilterRoute
 */
export function setFilterableRoute(state, isFilterRoute) {
  state.isFilterRoute = isFilterRoute;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {boolean} isOnDetailsPage
 */
export function setIsOnDetailsPage(state, isOnDetailsPage) {
  state.isOnDetailsPage = isOnDetailsPage;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {boolean} isLiveMapRoute
 */
export function setLiveMapRoute(state, isLiveMapRoute) {
  state.isLiveMapRoute = isLiveMapRoute;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {number} height
 */
export function setMainHeaderHeight(state, height) {
  state.mainHeaderHeight = height;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {number} height
 */
export function setPageHeaderHeight(state, height) {
  state.pageHeaderHeight = height;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {boolean} isOpen
 */
export function setMainNavOpen(state, isOpen) {
  state.mainNavOpen = isOpen;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {string} title
 */
export function setMobileTitle(state, title) {
  state.mobileTitle = title;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {string} title
 */
export function setPageTitle(state, title) {
  state.pageTitle = title;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {boolean} isPending
 */
export function setPageTitlePending(state, isPending) {
  state.pageTitlePending = Boolean(isPending);
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {IosNotchSizes} sizes
 */
export function setNotchSizes(state, sizes) {
  state.notchSizes = { ...state.notchSizes, ...sizes };
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {'portrait-primary' | 'landscape-primary' | 'landscape-secondary'} orientation
 */
export function setOrientation(state, orientation) {
  state.orientation = orientation;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function workersReady(state) {
  state.workersReadyResolve();
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {number} newOpenDialogCount
 */
export function setOpenZubieDialogCount(state, newOpenDialogCount) {
  state.openDialogCount = newOpenDialogCount;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function didTakeOff(state) {
  state.takeOff = true;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {Function}
 */
export function pollingError(state, dismiss) {
  state.pollingErrorDismiss = dismiss;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function clearPollingError(state) {
  state.pollingErrorDismiss = null;
}
